<!--
  提交订单
  Lovi 2020-07-02
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('life.submitOrder')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="content-wrapper">
      <scroll>
        <div class="order-detail">
          <div class="order-column">
            <van-cell
              class="van-cell-address"
              :title="
                address.address
                  ? address.address
                  : $t('personal.selectShippingAddress')
              "
              @click="addressListFlag = true"
              is-link
            >
              <template v-if="address.address" slot="label">
                <p>{{ address.house_number }}</p>
                <p>
                  {{ address.name }}
                  ({{
                    address.sex == 1
                      ? $t("common.Mr")
                      : address.sex == 2
                      ? $t("common.Ms")
                      : ""
                  }})
                  <span class="phone">{{ _phoneFormat(address.mobile) }}</span>
                </p>
              </template>
            </van-cell>
          </div>
          <!-- 产品信息 -->
          <div class="order-column">
            <div class="title">
              <h3>{{ routeData.shop_name }}</h3>
            </div>
            <div class="content">
              <div class="pro-wrap" :class="{ allPro: allProFlag }">
                <div
                  class="pro-item"
                  v-for="(pro, index) in routeData.prodcut_info"
                  :key="index"
                >
                  <div class="image">
                    <img :src="httpUrl + pro.image" />
                  </div>
                  <div class="info">
                    <div class="name-price">
                      <h3>{{ pro.product_name }}</h3>
                      <div class="price">
                        <span
                          v-if="pro.original_price"
                          class="original_price text-gray"
                        >
                          {{ pro.original_price }}P
                        </span>
                        <span class="text-red">{{ pro.selling_price }}P</span>
                      </div>
                    </div>
                    <p>X{{ pro.count }}</p>
                  </div>
                </div>
              </div>
              <div
                class="more-pro"
                v-if="
                  routeData.prodcut_info && routeData.prodcut_info.length > 3
                "
                @click="allProFlag = !allProFlag"
              >
                {{ allProFlag ? $t("life.fold") : $t("life.unfold") }}
                ({{ $t("shopCart.gong") }}
                {{ routeData.prodcut_info && routeData.prodcut_info.length }}
                {{ $t("shopCart.items") }})
                <van-icon :class="{ rotate: allProFlag }" name="arrow-down" />
              </div>

              <div class="van-cell-wrap">
                <van-cell
                  :title="$t('life.deliveryFee')"
                  :value="routeData.delivery_fee + 'P'"
                />
                <van-cell
                  :title="$t('life.packingFee')"
                  :value="routeData.packaging_fee + 'P'"
                />
                <van-cell :title="$t('coupon.goodsCashback')">
                  <template slot="default">
                    <span v-if="Number(fullReduction)" class="text-red">
                      -{{ fullReduction }}P
                    </span>
                    <span v-else class="text-gray">
                      {{ $t("common.nothing") }}
                    </span>
                  </template>
                </van-cell>

                <van-cell
                  v-if="coupon.cashback.length || coupon.voucher.length"
                  :title="$t('coupon.coupon')"
                  @click="couponFlag = true"
                  is-link
                >
                  <template slot="default">
                    <span class="text-red" v-if="couponAmount">
                      -{{ couponAmount }}P
                    </span>
                    <span v-else
                      >{{ couponAvailable
                      }}{{ $t("coupon.couponsAvailable") }}</span
                    >
                  </template>
                </van-cell>

                <van-cell
                  v-else
                  :title="$t('coupon.coupon')"
                  :value="$t('coupon.unavailable')"
                ></van-cell>
              </div>
              <div class="price-total">
                <span v-if="Number(discountMoney)">
                  {{ $t("life.discounted")
                  }}<i class="text-red">{{ discountMoney }}P</i>
                </span>
                <span>
                  {{ $t("life.total")
                  }}<i class="text-red total">{{ paymentAmount }}P</i>
                </span>
              </div>
            </div>
          </div>
          <!-- 备注 -->
          <van-cell :title="$t('common.note')" class="order-column remark">
            <van-field
              slot="label"
              v-model="remark"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              :placeholder="$t('common.enterNote')"
              show-word-limit
            />
          </van-cell>
        </div>
      </scroll>
    </div>

    <div class="submit">
      <div class="info">
        <span>
          {{ $t("life.total")
          }}<i class="total text-red">{{ paymentAmount }}P</i>
        </span>
        <span v-if="Number(discountMoney)">
          {{ $t("life.discounted")
          }}<i class="text-red">{{ discountMoney }}P</i>
        </span>
      </div>
      <van-button type="info" @click="createorder">
        {{ $t("common.confirmPayment") }}
      </van-button>
    </div>

    <!-- 地址列表 -->
    <transition name="slide">
      <address-list
        v-if="addressListFlag"
        :addressListFlag.sync="addressListFlag"
        :addressInfo="true"
        :shopId="routeData.shop_id"
        @getAddressInfo="getAddressInfo"
      />
    </transition>
    <!-- 选择优惠券 -->
    <transition name="slide">
      <coupon
        v-if="couponFlag"
        :couponFlag.sync="couponFlag"
        :coupon="coupon"
        :cashbackId.sync="cashbackId"
        :voucherId.sync="voucherId"
      />
    </transition>
  </div>
</template>

<script>
import _ from "lodash";
import AddressList from "@/views/personal/address";
import Coupon from "./coupon";
export default {
  name: "submitOrder",
  meta: {
    service: false // 客服
  },
  components: {
    AddressList,
    Coupon
  },
  data() {
    return {
      routeData: {}, //订单数据
      addressListFlag: false, //收货地址Flag
      address: {}, //收货地址
      allProFlag: false, //所有产品Flag
      moreProFlag: false, //更多产品Flag
      remark: "", //备注
      couponFlag: false, //优惠券Flag
      cashbackId: [],
      voucherId: "",
      coupon: {
        cashback: [],
        voucher: []
      },

      activity: [], // 满减信息
      originalPriceFlag: false, // 折扣商品
      originalPrice: 0, // 原价
      sellingPrice: 0, // 售价
      quantity: 0, // 商品数量
      totalAmount: 0, // 统计金额(商品总金额 + 包装费 + 配送费)
      shortAmount: 0, //还差多少金额 起送费 - (商品总金额 + 包装费 + 配送费)
      fullReduction: 0 // 满减
    };
  },
  created() {
    let vm = this;
    if (_.isEmpty(vm.$route.params)) {
      // 刷新页面要返回
      vm._back();
    } else {
      vm.routeData = vm.$route.params;
      console.log("routeData", vm.routeData);
    }
    vm.getDisccountStoreInfomation();
  },
  mounted() {},
  computed: {
    discountMoney() {
      // 优惠金额 原价 - 售价 + 满减 + 优惠券金额
      let vm = this;
      let money = 0;
      if (vm.originalPriceFlag) {
        money =
          Number(vm.originalPrice) -
          Number(vm.sellingPrice) +
          Number(vm.fullReduction) +
          Number(vm.couponAmount);
      } else {
        money = Number(vm.fullReduction) + Number(vm.couponAmount);
      }
      return money.toFixed(2);
    },
    paymentAmount() {
      // 实际原价金额 + 配送费 + 包装费 - 满减 - 优惠券金额
      let vm = this;
      let money = 0;
      money =
        Number(vm.sellingPrice) +
        Number(vm.routeData.packaging_fee) +
        Number(vm.routeData.delivery_fee) -
        Number(vm.fullReduction) -
        Number(vm.couponAmount);
      return money < 0 ? "0.00" : money.toFixed(2);
    },
    couponAmount() {
      // 计算优惠券金额
      let vm = this;
      let voucherMoney = 0;
      for (let key of vm.coupon.voucher) {
        if (vm.voucherId == key.id) {
          voucherMoney = Number(key.money);
        }
      }
      let cashbackMoney = 0;
      for (let key of vm.coupon.cashback) {
        for (let id of vm.cashbackId) {
          if (id == key.id) {
            cashbackMoney += Number(key.money);
          }
        }
      }
      return voucherMoney + cashbackMoney;
    },
    couponAvailable() {
      let voucherNum = 0;
      let voucher = this.coupon.voucher;
      for (let i = 0; i < voucher.length; i++) {
        if (voucher[i].usable == 1) {
          voucherNum += 1;
        }
      }
      let cashbackNum = 0;
      let cashback = this.coupon.cashback;
      for (let i = 0; i < cashback.length; i++) {
        if (cashback[i].usable == 1) {
          cashbackNum += 1;
        }
      }
      return voucherNum + cashbackNum;
    }
  },
  methods: {
    dataProcessing(arr) {
      // 购物车数据处理
      let vm = this;
      if (!arr || !arr.length) {
        return;
      }
      let originalPrice = 0; // 原价
      let originalPrice1 = 0;
      let sellingPrice = 0; // 售价
      let quantity = 0;
      let totalAmount = 0;
      let shortAmount = 0;
      let fullReduction = 0; // 已减金额
      let startingPrice = Number(vm.routeData.starting_price); // 起送费
      vm.originalPriceFlag = false;
      for (let i = 0; i < arr.length; i++) {
        let original_price = Number(arr[i].original_price);
        let selling_price = Number(arr[i].selling_price);
        let count = Number(arr[i].count);
        if (original_price) {
          // 有折扣商品
          vm.originalPriceFlag = true;
        }
        originalPrice1 +=
          count * (original_price ? original_price : selling_price);
        originalPrice += count * original_price;
        quantity += count;
        sellingPrice += count * selling_price;
      }
      // 满减商品
      if (vm.activity && vm.activity.length) {
        let activity = vm.activity.sort(this.arrSort("money"));
        console.log("activity", activity);
        if (!vm.originalPriceFlag) {
          for (let key of activity) {
            if (sellingPrice >= Number(key.money)) {
              fullReduction = Number(key.discount);
              break;
            }
          }
        }
      }
      // 总金额
      totalAmount =
        sellingPrice +
        Number(vm.routeData.delivery_fee) +
        Number(vm.routeData.packaging_fee);
      if (totalAmount < startingPrice) {
        // 还差多少起送
        shortAmount = startingPrice - totalAmount;
      } else {
        shortAmount = 0;
      }
      vm.originalPrice = vm.originalPriceFlag
        ? originalPrice1.toFixed(2)
        : originalPrice.toFixed(2);
      vm.sellingPrice = sellingPrice.toFixed(2);
      vm.quantity = quantity;
      vm.totalAmount = totalAmount.toFixed(2);
      vm.shortAmount = shortAmount.toFixed(2);
      vm.fullReduction = fullReduction.toFixed(2);
      vm.couponProcessing();
    },
    couponProcessing() {
      // 优惠券数据处理
      let vm = this;
      // 代金券
      let voucher = vm.routeData.coupon.voucher;
      vm.coupon.voucher = [];
      // 商家券优先
      voucher = voucher.sort(vm.arrSort("coupon_user_type"));
      // 券金额大优先
      voucher = voucher.sort(vm.arrSort("money"));
      let voucherList = [];
      // 加上可用标识 usable=1
      for (let key of voucher) {
        let obj = key;
        obj.usable = 1;
        voucherList.push(obj);
      }
      vm.coupon.voucher = voucherList.sort(this.arrSort("money"));
      if (vm.coupon.voucher.length) {
        vm.voucherId = vm.coupon.voucher[0].id;
      }

      // 满减券
      let cashback = vm.routeData.coupon.cashback;
      vm.coupon.cashback = [];
      vm.cashbackId = [];
      // 商家券优先
      cashback = cashback.sort(vm.arrSort("coupon_user_type"));
      // 条件金额大优先
      cashback = cashback.sort(vm.arrSort("coupon_amount"));
      // 券金额大优先
      cashback = cashback.sort(vm.arrSort("money"));
      let cashbackList = [];
      // 加上不用标识 usable=0
      for (let key of cashback) {
        let obj = key;
        obj.usable = 0;
        cashbackList.push(obj);
      }
      for (let i = 0; i < cashbackList.length; i++) {
        let obj = cashbackList[i];
        if (Number(vm.fullReduction)) {
          // 满减活动 - 与商家满减活动同享
          console.log("满减活动");
          if (
            (obj.coupon_user_type == 1 &&
              obj.offer_type.indexOf("3") != -1 &&
              Number(vm.sellingPrice) >= Number(obj.coupon_amount)) ||
            (obj.coupon_user_type == 2 &&
              obj.offer_type == 0 &&
              Number(vm.sellingPrice) >= Number(obj.coupon_amount))
          ) {
            // 与商家满减活动共享(平台券offer_type=3，商家券offer_type=0)
            obj.usable = 1;
            vm.$set(cashbackList, i, obj);
          }
        } else {
          if (
            (obj.coupon_user_type == 1 &&
              obj.offer_type != 3 &&
              Number(vm.sellingPrice) >= Number(obj.coupon_amount)) ||
            (obj.coupon_user_type == 2 &&
              Number(vm.sellingPrice) >= Number(obj.coupon_amount))
          ) {
            // 与商家满减券同享
            obj.usable = 1;
            vm.$set(cashbackList, i, obj);
          }
        }
      }
      cashbackList = cashbackList.sort(vm.arrSort("usable"));
      console.log("cashbackList", cashbackList);
      let type1_23 = []; //平台券 - 与商家满减券同享、与商家满减活动同享
      let type1_2 = []; //平台券 - 与商家满减券同享
      let type1_3 = []; //平台券 - 与商家满减活动同享
      let type2_04 = []; //商家券 - 与满减活动同享
      let type2_0 = []; //商家券 - 不与满减活动同享
      for (let key of cashbackList) {
        if (key.usable == 1) {
          if (key.coupon_user_type == 1) {
            //平台券
            if (key.offer_type != 1) {
              //与商家满减券同享、与商家满减活动同享
              type1_23.push(key);
            }
            if (key.offer_type.indexOf("2") != -1) {
              //与商家满减券同享
              type1_2.push(key);
            }
            if (key.offer_type.indexOf("3") != -1) {
              //与商家满减活动同享
              type1_3.push(key);
            }
          } else {
            //商家券
            type2_04.push(key);
            if (key.offer_type == 0) {
              // 与满减活动同享
              type2_0.push(key);
            }
          }
        }
      }
      console.log("type1_23", type1_23);
      console.log("type1_2", type1_2);
      console.log("type1_3", type1_3);
      console.log("type2_04", type2_04);
      console.log("type2_0", type2_0);
      // 如果有可用优惠券-默认选中第一张优惠券
      if (cashbackList.length && cashbackList[0].usable == 1) {
        let current = cashbackList[0];
        vm.cashbackId.push(current.id);
        if (current.coupon_user_type == 1) {
          // 默认选中第一张优惠券 - 平台券
          if (current.offer_type.indexOf("2") != -1 && type2_04.length) {
            // 与商家满减券同享
            vm.cashbackId.push(type2_04[0].id);
          } else if (current.offer_type.indexOf("3") != -1 && type2_0.length) {
            // 与商家满减活动同享
            vm.cashbackId.push(type2_0[0].id);
          }
        } else {
          // 默认选中第一张优惠券 - 商家券
          if (current.offer_type == 0 && type1_23.length) {
            // 与满减活动同享
            vm.cashbackId.push(type1_23[0].id);
          } else if (current.offer_type == 4 && type1_2.length) {
            // 不与满减活动同享
            vm.cashbackId.push(type1_2[0].id);
          }
        }
      }
      vm.coupon.cashback = cashbackList;
      console.log(vm.voucherId, vm.cashbackId);
      // vm.calculateCouponAmount();
    },
    calculateCouponAmount() {
      // 计算优惠券金额
      let vm = this;
      let voucherMoney = 0;
      for (let key of vm.coupon.voucher) {
        if (vm.voucherId == key.id) {
          voucherMoney = Number(key.money);
        }
      }
      let cashbackMoney = 0;
      for (let key of vm.coupon.cashback) {
        for (let id of vm.cashbackId) {
          if (id == key.id) {
            cashbackMoney += Number(key.money);
          }
        }
      }
      vm.couponAmount = voucherMoney + cashbackMoney;
    },
    arrSort(key, bol) {
      // 排序的数组的key值
      return function(a, b) {
        let value1 = a[key];
        let value2 = b[key];
        if (bol) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    getAddressInfo(data) {
      // 获取地址信息
      console.log("getAddressInfo", data);
      this.address = data;
    },
    createorder() {
      // 提交订单
      let vm = this;
      if (!vm.address.id) {
        vm.$toast(vm.$t("personal.selectShippingAddress"));
        return false;
      }
      let list = [];
      for (let i = 0; i < vm.routeData.prodcut_info.length; i++) {
        let obj = {};
        obj.product_id = vm.routeData.prodcut_info[i].product_id;
        obj.count = vm.routeData.prodcut_info[i].count;
        list.push(obj);
      }
      let params = {};
      params.shop_id = vm.routeData.shop_id;
      params.address_id = vm.address.id;
      params.list = JSON.stringify(list);
      params.total_price = vm.paymentAmount;
      params.remarks = vm.remark;
      debugger
      let couponId = vm.cashbackId;
      couponId.push(vm.voucherId);
      params.coupon_id = couponId.join(",");
      params.activity_money = vm.fullReduction;
      params.delivery_fee=vm.routeData.delivery_fee;
      params.packaging_fee=vm.routeData.packaging_fee;
      params.total_discount_amount=vm.discountMoney;
      vm.$post("/app/order/createorder", params, { loading: true }).then(
        res => {
          console.log("createorder", res);
          vm.$store.dispatch("SET_SHOPCART_DATA", "delete");
          vm.$router.replace({
            path: "/payOrder",
            name: "payOrder",
            params: res
          });
        }
      );
    },
    getDisccountStoreInfomation() {
      //店铺优惠信息
      let vm = this;
      let params = {};
      params.shop_id = vm.routeData.shop_id;
      vm.$post("/app/store/getDisccountStoreInfomation", params, {
        loading: true
      }).then(res => {
        console.log("getDisccountStoreInfomation", res);
        vm.activity = res.list.activity;
        vm.dataProcessing(vm.routeData.prodcut_info);
      });
    },
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.content-wrapper {
  background: #f4f4f4;
  .order-detail {
    padding: 1.1px 0;
  }
}
.order-column {
  margin: 10px;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    height: 40px;
    border-bottom: 1.1px solid #e3e3e3;
    h3 {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .content {
    padding: 10px;
  }
}

.van-cell-address {
  display: flex;
  align-items: center;
}

.pro-wrap {
  max-height: 200px;
  overflow: hidden;
  &.allPro {
    max-height: initial;
  }
  .pro-item {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    height: 60px;
    &:first-child {
      margin-top: 0;
    }
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
      }
      p {
        padding-top: 5px;
      }
      .name-price {
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        h3 {
          flex: 1;
          margin-right: 5px;
        }
      }
      .price {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          &.text-red {
            font-size: 15px;
          }
          &.original_price {
            margin-right: 5px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
.more-pro {
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/.van-icon {
    margin-left: 2px;
    font-size: 14px;
    transition: transform 0.5s;
    &.rotate {
      transform: rotate(180deg);
    }
  }
}

.van-cell-wrap {
  margin-top: 10px;
  /deep/.van-cell {
    padding: 5px 0;
    &::after {
      content: normal;
    }
    .van-cell__title {
      margin-right: 10px;
      flex: initial;
    }
    .van-cell__value {
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

.price-total {
  padding-top: 10px;
  text-align: right;
  font-size: 14px;
  line-height: 1;
  border-top: 1.1px solid #e3e3e3;
  span {
    margin-left: 10px;
  }
  .total {
    font-size: 20px;
  }
}

.remark {
  padding: 10px;
  width: calc(100% - 20px);
  /deep/.van-field {
    padding: 0;
  }
}

.submit {
  z-index: 90;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  background: #fff;
  box-shadow: 0px 0px 3px 0px rgba(221, 221, 221, 0.5);
  .info {
    flex: 1;
    padding: 10px;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      margin-left: 15px;
      &:first-child {
        margin-left: 0;
      }
      .total {
        font-size: 20px;
      }
    }
  }
  /deep/.van-button {
    padding: 0;
    width: 100px;
    height: 50px;
    line-height: 1.2;
    border-radius: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &.van-button--disabled {
      font-size: 14px;
      color: #bababa;
      background: #6c6c6c;
    }
  }
}
</style>
